import styled from 'styled-components';
import { Button } from 'antd';
import { darken, lighten } from 'polished';

const StyledColoredButton = styled(Button)`
    background-color: ${props => props.bg};
    border: 1px solid ${props => props.border || props.bg};
    color: ${props => props.color || '#fff'};
    width: ${props => props.width || 'auto'};
    margin-bottom: 0;

    &:hover, &:focus, &.active, &.ant-btn-loading {
        background-color: ${props => (!['#ffffff', '#fff'].includes(props.bg.toLowerCase()) ? darken(0.1, props.bg) : '#fff')} !important;
        border: 1px solid ${props => darken(0.1, props.border || props.bg)} !important;
        color: ${props => (props.color ? darken(0.1, props.color) : '#fff')} !important;
    }

    &:disabled {
        border: 1px solid ${props => darken(0.1, props.border || props.bg)} !important;
        background-color: ${props => lighten(0.1, props.bg)} !important;
        color: ${props => (props.color ? darken(0.1, props.color) : '#fff')} !important;
    }
`;

export default StyledColoredButton;
